export const modals = {
  copy: 'Kopiuj szablon konfiguracji',
  copySuccess: 'Skopiowano szablon konfiguracji',
  delete: 'Usuń szablon konfiguracji',
  deleteConfirm: 'Czy na pewno chcesz usunąć szablon konfiguracji?',
  deleteSuccess: 'Usunięto szablon konfiguracji',
  publishCollisionTitle:
    'Istnieje już opublikowany szablon konfiguracji o tych samych kryteriach',
  publishCollisionDescription:
    'Publikacja tego szablonu konfiguracji spowoduje archiwizację szablonu z listy poniżej.',
  publishCollisionFlowName: 'Nazwa szablonu konfiguracji',
  publishCollisionAuthor: 'Autor',
  publishCollisionCreatedAt: 'Data utworzenia',
} as const
